'use client';

import { Icon, Select } from '@mage-ui/components';
import { cx } from '@mage-ui/styled-system/css';
import {
	bordersWrapper,
	comboboxSection,
	courseSection,
	gridCol,
	gridRow,
	icon,
	input,
	inputLabel,
	inputRoot,
	inputSection,
	selectButton,
	selectSection,
} from '@mage-ui/styled-system/recipes';
import { parseAsString, useQueryState } from 'nuqs';
import { useContext } from 'react';
import { StaticTextContext } from '@/components/context/StaticTextProvider';
import { GridCol } from '../../layouts/grids/GridCol';
import { GridRow } from '../../layouts/grids/GridRow';

const getLanguageOptions = (languages) =>
	languages
		.map(({ fields }) => fields)
		.filter((fields) => fields?.iso && fields?.id_backend)
		.map(({ iso, name }) => ({ id: iso, value: name }))
		.sort((a, b) => a.value.localeCompare(b.value));

export const DossierLanguageFilter = ({ languages, startTransition }) => {
	const { st } = useContext(StaticTextContext);

	const [language, setLanguage] = useQueryState(
		st('language.key'),
		parseAsString.withDefault('').withOptions({
			shallow: false,
			scroll: false,
			startTransition,
		}),
	);

	const allLanguagesOption = { id: '', value: st('register.all_languages') };
	const options = [allLanguagesOption, ...getLanguageOptions(languages)];
	const selectedOption =
		options.find((option) => option.id === language) ?? allLanguagesOption;

	const onLanguageChange = (option) => {
		setLanguage(option?.id || null);
	};

	return (
		<div className={courseSection().filtersWrapper}>
			<div className={cx(bordersWrapper(), courseSection().filters)}>
				<GridRow className={gridRow({ gap: 'gap100', gapM: 'gap500' })}>
					<GridCol className={gridCol({ colSpanM: '6', colSpanL: '6' })}>
						<Select
							label={st('register.select_language')}
							placeholder={st('register.all_languages')}
							selectedOption={selectedOption}
							setSelectedOption={onLanguageChange}
							endSlot={
								<Icon name='arrow_drop_down' classNames={icon({ size: 's' })} />
							}
							classNames={{
								root: inputRoot({ direction: 'row' }),
								input: cx(
									input({ color: 'primary', size: 'xl', border: '100' }),
									selectButton(),
								),
								section: cx(inputSection(), comboboxSection(), selectSection()),
								label: inputLabel({
									color: 'primary',
									display: 'desktop',
									weight: 'bold',
								}),
							}}
							options={options}
						/>
					</GridCol>
				</GridRow>
			</div>
		</div>
	);
};
